export enum PublicBrandCosmeticSortType {
  CreatedAtAscending,
  CreatedAtDescending,
  NameAscending,
  NameDescending,
}
